import { Center } from '@zorro/web/design-system';

import { SVGIconProps } from '../types';

export const HexagonalExclamationIcon = ({ style }: SVGIconProps) => {
  return (
    <Center style={style}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <g clipPath="url(#clip0_1951_9655)">
          <path
            d="M13.25 4.18233C13.7167 4.44766 14.0033 4.94433 14 5.481V10.337C14 10.8763 13.7047 11.3737 13.228 11.6357L8.728 14.4823C8.5049 14.6048 8.25451 14.669 8 14.669C7.74549 14.669 7.4951 14.6048 7.272 14.4823L2.772 11.6357C2.53878 11.5082 2.34408 11.3204 2.20827 11.092C2.07247 10.8635 2.00053 10.6028 2 10.337V5.48033C2 4.941 2.29533 4.44433 2.772 4.18233L7.272 1.529C7.50169 1.40235 7.75971 1.33594 8.022 1.33594C8.28429 1.33594 8.54231 1.40235 8.772 1.529L13.272 4.18233H13.25Z"
            stroke="#1A1721"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8 5.33594V8.0026"
            stroke="#1A1721"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8 10.6641H8.00667"
            stroke="#1A1721"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1951_9655">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </Center>
  );
};
